import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setCreateButton, setHeadBtns, setSearchHandler, setSearchString, setTitle} from "../actions/main";
import {Link, useNavigate, useParams} from "react-router-dom";
import TableView from "../components/TableView";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {ClientService} from "../services/ClientService";
import {ArtistService} from "../services/ArtistService";
import {ConfirmPopup} from "primereact/confirmpopup";
import Total from "../components/Total";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import {Dialog} from "primereact/dialog";
import Formater from "../helpers/formater";
import {Calendar} from "primereact/calendar";
import formater from "../helpers/formater";

function Artists() {

    const dispatch = useDispatch()
    const locationParams = useParams()
    const [data, setData] = useState(false)
    const [loading, setLoading] = useState(true)
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const navigation = useNavigate()

    const [dialogVisible, setDialogVisible] = useState(false)
    const [exportDialogVisible, setExportDialogVisible] = useState(false)


    let defaultColumns = [
        // {name: 'id', label: '№', selected: true},
        {name: 'name', label: 'Название/имя артиста', selected: true},
        {name: 'phone', label: 'Телефон директора', selected: true},
        {name: 'phone2', label: 'Телефон админа', selected: true},
        {name: 'phone3', label: 'Телефон тех.', selected: true}
        // {name: 'client', label: 'Источник', selected: true},
    ];


    function setTableRowsHandler(data) {
        setTableRows(data)
    }


    function updateData(params) {


        ArtistService.GetList(params, '').then((response, h) => {

            // if (response.items) {
            setData(response)
            setLoading(false)

        })
    }


    const objectToCSVRow = function(dataObject) {
        var dataArray = new Array;
        for (var o in dataObject) {
            var innerValue = dataObject[o]===null?'':dataObject[o].toString();
            var result = innerValue.replace(/"/g, '""');
            result = '"' + result + '"';
            dataArray.push(result);
        }
        return dataArray.join(',') + '\r\n';
    }

    const exportToCSV = function(arrayOfObjects) {

        if (!arrayOfObjects.length) {
            return;
        }

        var csvContent = "data:text/csv;charset=utf-8,";

        // headers
        csvContent += objectToCSVRow(Object.keys(arrayOfObjects[0]));

        arrayOfObjects.forEach(function(item){
            csvContent += objectToCSVRow(item);
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "Артисты.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
    }

    const moreFields = [
        'ID',
        'Название/Имя артиста',
        'Телефон директора',
        'Телефон админа',
        'Телефон тех.',
        'Комментарий',
    ]

    const [moreFieldsSelected, setMoreFieldsSelected] = useState(moreFields)


    const getEventFieldValue = (currentEvent, field) =>{
        let v
        switch (field){
            case 'ID':
                v = currentEvent.id;
                break;
            case 'Название/Имя артиста':
                v = currentEvent.name;
                break;
            case 'Телефон директора':
                v = currentEvent.phone;
                break;
            case 'Телефон админа':
                v = currentEvent.phone2;
                break;
            case 'Телефон тех.':
                v = currentEvent.phone3;
                break;
            case 'Комментарий':
                v = currentEvent.comment;
                break;

        }
        return v
    }

    const getExportData = () => {
        let exportData = []

        console.log(data)
        data.items.map((artist) => {
            let eventData = {

            }
            moreFieldsSelected.map((field) => {
                eventData[field] = getEventFieldValue(artist, field)
            })
            console.log(eventData)
            exportData.push(eventData)
        })

        console.log(exportData)
        exportToCSV(exportData)

        // var form = document.createElement('form');
        // document.body.appendChild(form);
        // form.method = 'post';
        // form.action = 'http://yii2.easytickets.pro/site/export';
        // for (var name in data) {
        //     var input = document.createElement('input');
        //     input.type = 'hidden';
        //     input.name = name;
        //     input.value = JSON.stringify(data[name]);
        //     form.appendChild(input);
        // }
        // form.submit();
    }

    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-pencil',
            command: (e) => {
                navigation('/artist/' + e.item.rowId)
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить этого артиста?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {
                        ArtistService.Delete(e.item.rowId).then((response) => {
                            updateData()
                        })
                    },
                    acceptLabel: 'Да',
                    reject: () => {
                        return false
                    },
                    rejectLabel: 'Нет'
                });
            }
        }
    ];


    const handlerRawActions = (elId) => {
        const currentRow = data.items.find((el) => {
            return el.id === elId
        })

        if (currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId


            })

            return rowActions;
        }
    }


    const tableValue = (propName, el) => {
        switch (propName) {
            case 'name':
                return <Link to={'/artist/' + el.id}>{el[propName]}</Link>
                break

            default:

                return (
                    el[propName]
                )
        }
    }

    const [tableRows, setTableRows] = useState(defaultColumns)

    const searchHandler = (e, string) => {


        setLoading(true)
        updateData({
            filter: {
                client_id: currentDepartment,
                s: string
            }
        })

        e.preventDefault()

    }

    useEffect(() => {
        dispatch(setTitle('Артисты'))
        dispatch(setHeadBtns([
            {
                icon: 'pi pi-file-export',
                text: 'Экспорт',
                className: 'p-button-text',
                handler: (e) => {
                    setExportDialogVisible(true)
                }
            }
        ]))
        dispatch(setCreateButton('artist/create'))
        dispatch(setSearchHandler(searchHandler))
        dispatch(setSearchString(''))
        if (currentDepartment) {
            updateData({filter: {client_id: currentDepartment}})
        }
        return () => {
            dispatch(setHeadBtns([]))
        }
    }, [currentDepartment]);

    const handlePageClick = (event) => {
        setLoading(true);
        updateData({client_id: currentDepartment, page: ++event.selected})
    }

    return (
        <div className={'product-wrapper'}>


            <ConfirmDialog/>
            <Dialog header={() => {
                return <>Выберите поля</>
            }} style={{'width': '500px'}} onHide={() => setExportDialogVisible(false)} visible={exportDialogVisible} footer={() => {
                return (
                    <Button label={'Скачать'} className={'p-button-text'} icon={'pi pi-file-export'} text={true} onClick={() => {
                        getExportData()
                        setExportDialogVisible(false)
                    }}/>
                )
            }}>
                <div className={'d-flex flex-column gap-3'}>

                    {moreFields.map((field, k) => {
                        return <div key={k} className={'d-flex gap-3 align-items-center'}><Checkbox inputId={'export-field-' + k} value={field} checked={moreFieldsSelected.includes(field)} onChange={(e) => {
                            let newData = []
                            if(e.checked){
                                newData = [...moreFieldsSelected, e.value]
                                setMoreFieldsSelected(newData)
                            } else {
                                newData = JSON.parse(JSON.stringify(moreFieldsSelected))

                                newData.splice(newData.indexOf(e.value), 1)
                                setMoreFieldsSelected(newData)
                            }
                            console.log(newData)
                        }}></Checkbox><label htmlFor={'export-field-' + k} className={'p-checkbox-label mb-0 pb-0'}>{field}</label></div>
                    })}
                </div>


            </Dialog>
            <div className="card">
                <TableView id={'artists-list'} tableRows={tableRows} data={data}
                           tableValue={tableValue}
                           loading={loading}

                           setTableRows={setTableRowsHandler} handleEdit={(e) => ''} rowActions={rowActions}
                           massRowActions={false} massActionHander={false}
                           rowActionsHandler={handlerRawActions}
                           hideSettings={true}
                           tableClass={'artists-table'}/>
            </div>

            <Total data={data} handlePageClick={handlePageClick}/>
        </div>
    )
}

export default Artists